export enum OperationType {
  pendingOperation,
  signupFinalization,
  userMigration,
  externalMatching,
}

export interface PendingPageData {
  title?: string
  description?: string
  operationType?: OperationType
  pendingData?: PendingData
  submitButtonLabel?: string
}

export interface PendingData {
  mobileCountryCode?: string
  mobileNumber?: string
  email?: string
  password?: string
  firstName?: string
  lastName?: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPendingData = (data: PendingData | any): data is PendingData =>
  ((data as PendingData)?.mobileCountryCode !== undefined && (data as PendingData)?.mobileNumber !== undefined) ||
  (data as PendingData)?.email !== undefined
